import { X, Search, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";

export const ferr = (e, fb) => toast.error(formatApiError(e.response?.data?.detail) || fb);

const STATUS_STYLES = {
  complete: "bg-emerald-100 text-emerald-700",
  processing: "bg-sky-100 text-sky-700",
  in_queue: "bg-amber-100 text-amber-700",
  failed: "bg-rose-100 text-rose-700",
  pending_payment: "bg-slate-100 text-slate-600",
  paid: "bg-emerald-100 text-emerald-700",
  refunded: "bg-violet-100 text-violet-700",
  pending: "bg-slate-100 text-slate-600",
  initiated: "bg-slate-100 text-slate-600",
};

export const Badge = ({ value }) => (
  <span className={`inline-block px-2 py-0.5 rounded-full text-[11px] font-bold ${STATUS_STYLES[value] || "bg-slate-100 text-slate-600"}`}>
    {String(value || "—").replace(/_/g, " ")}
  </span>
);

export const money = (v) => `$${Number(v || 0).toFixed(2)}`;
export const date = (v) => (v ? new Date(v).toLocaleString() : "—");

export const Modal = ({ title, onClose, children }) => (
  <div className="fixed inset-0 z-50 bg-black/50 flex justify-end" onClick={onClose} data-testid="admin-modal">
    <div className="w-full max-w-lg bg-fieldstone h-full overflow-y-auto shadow-2xl" onClick={(e) => e.stopPropagation()}>
      <div className="sticky top-0 bg-navy text-white px-5 py-3.5 flex items-center justify-between">
        <h3 className="font-bold text-[15px]">{title}</h3>
        <button onClick={onClose} className="text-white/80 hover:text-white" data-testid="admin-modal-close"><X size={20} /></button>
      </div>
      <div className="p-5">{children}</div>
    </div>
  </div>
);

export const downloadPdf = async (id) => {
  try {
    const res = await api.get(`/admin/reports/${id}/pdf`, { responseType: "blob" });
    const url = URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
    const a = document.createElement("a");
    a.href = url; a.download = `MeasureTheRoof-${id}.pdf`;
    document.body.appendChild(a); a.click(); a.remove(); URL.revokeObjectURL(url);
  } catch (e) { ferr(e, "Couldn't download PDF."); }
};

export const SearchBar = ({ value, onChange, placeholder, testid }) => (
  <div className="relative mb-4">
    <Search size={18} className="absolute left-3.5 top-1/2 -translate-y-1/2 text-mortar" />
    <input className="input-mtr pl-11" placeholder={placeholder} value={value} onChange={(e) => onChange(e.target.value)} data-testid={testid} />
  </div>
);

export const Table = ({ cols, children, loading, empty }) => (
  <div className="bg-white rounded-card border border-gravel overflow-x-auto">
    <table className="w-full text-left text-[13px]">
      <thead><tr className="text-mortar text-[11px] uppercase tracking-wide">{cols.map((c, i) => <th key={i} className="px-4 py-3 font-bold">{c}</th>)}</tr></thead>
      <tbody>
        {loading ? <tr><td colSpan={cols.length} className="px-4 py-10 text-center"><Loader2 className="animate-spin text-mortar inline" /></td></tr>
          : empty ? <tr><td colSpan={cols.length} className="px-4 py-10 text-center text-mortar">No records.</td></tr>
            : children}
      </tbody>
    </table>
  </div>
);
